import { render, staticRenderFns } from "./AscentCragRouteStatusIcon.vue?vue&type=template&id=272aa5e8"
import script from "./AscentCragRouteStatusIcon.vue?vue&type=script&lang=js"
export * from "./AscentCragRouteStatusIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports